/** Suivi d'usage local des activités (par appareil), pour trier le picker :
 * les activités déjà lancées remontent en tête. Zéro backend — localStorage. */

const USAGE_KEY = "senacle-workforce.activityUsage";

export interface ActivityUsageEntry {
  count: number;
  lastUsedAt: number;
}

export type ActivityUsage = Record<string, ActivityUsageEntry>;

export function getActivityUsage(): ActivityUsage {
  try {
    const raw = localStorage.getItem(USAGE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return {};
    return parsed as ActivityUsage;
  } catch {
    return {};
  }
}

export function recordActivityUsage(code: string): void {
  if (!code) return;
  try {
    const usage = getActivityUsage();
    const prev = usage[code];
    usage[code] = {
      count: (prev?.count ?? 0) + 1,
      lastUsedAt: Date.now(),
    };
    localStorage.setItem(USAGE_KEY, JSON.stringify(usage));
  } catch {
    // localStorage indisponible (mode privé, quota) — l'usage n'est pas critique.
  }
}

/** Tri stable : d'abord les activités utilisées (count desc, puis lastUsedAt desc),
 * ensuite les jamais-utilisées dans leur ordre d'entrée (déjà sort_order). Ne mute pas `items`. */
export function sortByUsage<T extends { code: string }>(
  items: T[],
  usage: ActivityUsage,
): T[] {
  return items
    .map((item, index) => ({ item, index, u: usage[item.code] }))
    .sort((a, b) => {
      const ua = a.u?.count ?? 0;
      const ub = b.u?.count ?? 0;
      if (ua > 0 !== ub > 0) return ua > 0 ? -1 : 1;
      if (ua > 0 && ub > 0) {
        if (ub !== ua) return ub - ua;
        const la = a.u?.lastUsedAt ?? 0;
        const lb = b.u?.lastUsedAt ?? 0;
        if (lb !== la) return lb - la;
      }
      return a.index - b.index;
    })
    .map((x) => x.item);
}
